<div class="flex flex-col items-center gap-[53px] md:gap-[38px]">
  <!-- Birthday cake, as on the app's birth year screen -->
  <div *ngIf="question.icon === 'birthday'" class="-mb-[29px] flex size-[60px] items-center justify-center rounded-full border-2 border-[#5D38F1] md:-mb-[14px]" aria-hidden="true">
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
      <path d="M10 9v5M16 9v5M22 9v5" />
      <path d="M10 4.5c-.9 1.2-.9 2.3 0 3 .9-.7.9-1.8 0-3ZM16 4.5c-.9 1.2-.9 2.3 0 3 .9-.7.9-1.8 0-3ZM22 4.5c-.9 1.2-.9 2.3 0 3 .9-.7.9-1.8 0-3Z" />
      <rect x="5" y="14" width="22" height="13" rx="1.5" />
      <path d="M5 18.5c2 2 3.5 2 5.5 0s3.5-2 5.5 0 3.5 2 5.5 0 3.5-2 5.5 0" />
      <path d="M3 27h26" />
    </svg>
  </div>

  <h2 class="max-w-[275px] text-center text-2xl font-bold leading-[30px] md:max-w-none">{{ question.title }}</h2>

  <!-- Scroller: rows sit at 40 / 97 / 154px; the selected row is boxed -->
  <div class="relative h-[194px] max-w-full select-none" [ngClass]="hasUnitColumn || hasFraction ? 'w-[250px]' : 'w-[300px]'">
    <div class="pointer-events-none absolute inset-x-0 top-[71px] h-[56px] rounded-[5px] border-2 border-[#5D38F1] bg-white shadow-[inset_0px_4px_10px_0px_rgba(0,0,0,0.25)]"></div>

    <!-- Units without decimals drop the fraction column and its divider -->
    <div class="relative grid h-full" [ngClass]="gridColumns">
      <!-- Whole number -->
      <div
        class="relative h-full touch-none outline-none"
        tabindex="0"
        role="spinbutton"
        aria-label="Whole number"
        [attr.aria-valuenow]="wholeRow(0)"
        (keydown.arrowup)="step('whole', -1); $event.preventDefault()"
        (keydown.arrowdown)="step('whole', 1); $event.preventDefault()"
        (wheel)="onWheel('whole', $event)"
        (pointerdown)="onPointerDown('whole', $event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp()"
        (pointercancel)="onPointerUp()"
      >
        <button *ngIf="wholeRow(-1) !== null" type="button" tabindex="-1" [ngClass]="wholeAlign" class="absolute top-[40px] -translate-y-1/2 text-[26px] font-medium leading-none text-[#BEBDC1]" (click)="pick('whole', -1)">{{ wholeRow(-1) }}</button>
        <span [ngClass]="wholeAlign" class="absolute top-[97px] -translate-y-1/2 text-4xl font-black leading-none">{{ wholeRow(0) }}</span>
        <button *ngIf="wholeRow(1) !== null" type="button" tabindex="-1" [ngClass]="wholeAlign" class="absolute top-[154px] -translate-y-1/2 text-[26px] font-medium leading-none text-[#BEBDC1]" (click)="pick('whole', 1)">{{ wholeRow(1) }}</button>
      </div>

      <!-- Fraction -->
      <div *ngIf="hasFraction" class="my-[21px] w-px bg-black/10"></div>
      <div
        *ngIf="hasFraction"
        class="relative h-full touch-none outline-none"
        tabindex="0"
        role="spinbutton"
        aria-label="Decimal"
        [attr.aria-valuenow]="fractionRow(0)"
        (keydown.arrowup)="step('fraction', -1); $event.preventDefault()"
        (keydown.arrowdown)="step('fraction', 1); $event.preventDefault()"
        (wheel)="onWheel('fraction', $event)"
        (pointerdown)="onPointerDown('fraction', $event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp()"
        (pointercancel)="onPointerUp()"
      >
        <button *ngIf="fractionRow(-1) !== null" type="button" tabindex="-1" class="absolute left-1 top-[40px] -translate-y-1/2 text-[26px] font-medium leading-none text-[#BEBDC1]" (click)="pick('fraction', -1)">{{ fractionRow(-1) }}</button>
        <span class="absolute left-1 top-[97px] -translate-y-1/2 text-4xl font-black leading-none">{{ fractionRow(0) }}</span>
        <button *ngIf="fractionRow(1) !== null" type="button" tabindex="-1" class="absolute left-1 top-[154px] -translate-y-1/2 text-[26px] font-medium leading-none text-[#BEBDC1]" (click)="pick('fraction', 1)">{{ fractionRow(1) }}</button>
      </div>

      <div *ngIf="hasUnitColumn" class="my-[21px] w-px bg-black/10"></div>

      <!-- Unit -->
      <div
        *ngIf="hasUnitColumn"
        class="relative h-full touch-none outline-none"
        tabindex="0"
        role="spinbutton"
        aria-label="Unit"
        [attr.aria-valuetext]="unit.label"
        (keydown.arrowup)="step('unit', -1); $event.preventDefault()"
        (keydown.arrowdown)="step('unit', 1); $event.preventDefault()"
        (wheel)="onWheel('unit', $event)"
        (pointerdown)="onPointerDown('unit', $event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp()"
        (pointercancel)="onPointerUp()"
      >
        <button *ngIf="unitRow(-1) !== null" type="button" tabindex="-1" class="absolute inset-x-0 top-[40px] -translate-y-1/2 text-center text-base leading-[22px] text-[#BEBDC1]" (click)="pick('unit', -1)">{{ unitRow(-1) }}</button>
        <span class="absolute inset-x-0 top-[97px] -translate-y-1/2 text-center text-base font-black leading-[22px]">{{ unit.label }}</span>
        <button *ngIf="unitRow(1) !== null" type="button" tabindex="-1" class="absolute inset-x-0 top-[154px] -translate-y-1/2 text-center text-base leading-[22px] text-[#BEBDC1]" (click)="pick('unit', 1)">{{ unitRow(1) }}</button>
      </div>
    </div>
  </div>

  <button
    type="button"
    class="flex h-[55px] w-full items-center justify-center rounded-full bg-black px-9 text-[15px] font-bold uppercase leading-5 tracking-[1.5px] text-white"
    (click)="submit()"
  >Next</button>
</div>
